import styled from 'styled-components';
import { device } from '../../utils/styled-component-mixins';

export const withMobileOnlyStyles = (Component) => styled(Component)`
  @media ${device.desktop} {
    display: none;
    visibility: none;
  }
`;

export const withDesktopOnlyStyles = (Component) => styled(Component)`
  @media ${device.deviceOnly} {
    display: none;
    visibility: none;
  }
`;
